// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__40zCW","alert":"SettungsInbox_alert__f150V"};